<ng-template>
  <div class="global-ui-dropdown" [@visibility]="state" #panel>
    <ng-content></ng-content>
  </div>
</ng-template>
